<template>
  <div class="not-found-view">
    <svg class="illustration" viewBox="0 0 523 235" aria-hidden="true">
      <path class="four" fill-rule="evenodd" d="M74 25H143V129H171V165H143V202H97V165H0V129ZM38 129L97 50V129Z"/>
      <!-- The Fransys head, its mouth turned down. -->
      <g class="head" transform="translate(191 0) scale(7.8333)">
        <path d="M9.002 7.594C9.012 8.169 9.251 8.718 9.667 9.121C10.083 9.524 10.642 9.75 11.225 9.75H16.133C16.429 9.749 16.714 9.632 16.923 9.424C17.132 9.217 17.25 8.936 17.25 8.643V7.532C17.234 5.53 16.418 3.614 14.979 2.204C13.54 0.793 11.594 0.001 9.567 0H8.433C6.405 0.001 4.46 0.793 3.021 2.204C1.582 3.614 0.766 5.53 0.75 7.532V8.643C0.75 8.936 0.868 9.217 1.077 9.424C1.286 9.632 1.571 9.749 1.867 9.75H6.775C7.358 9.75 7.918 9.524 8.335 9.121C8.751 8.718 8.991 8.17 9.002 7.594Z"/>
        <path fill-rule="evenodd" d="M9.746 12V13.94H8.254V12H0V16.5H8.254V14.556H9.746V16.5H18V12H9.746ZM6.886 15.124H1.352V13.356H6.874L6.886 15.124ZM16.632 15.124H11.114V13.356H16.632V15.124Z"/>
        <path fill-rule="evenodd" d="M0.75 22.218C0.75 24.281 1.559 26.26 3 27.719C4.441 29.179 6.396 29.999 8.434 30H9.566C11.605 29.999 13.559 29.179 15 27.719C16.441 26.26 17.25 24.281 17.25 22.218V18.862C17.25 18.832 17.238 18.804 17.218 18.783C17.197 18.762 17.169 18.75 17.14 18.75H0.861C0.831 18.749 0.802 18.76 0.781 18.782C0.761 18.803 0.75 18.832 0.75 18.862V22.218ZM5.584 24.239H12.416C12.416 23.413 12.092 22.622 11.515 22.038C10.939 21.455 10.157 21.127 9.341 21.127H8.659C7.843 21.127 7.061 21.455 6.485 22.038C5.908 22.622 5.584 23.413 5.584 24.239Z"/>
      </g>
      <path class="four" fill-rule="evenodd" transform="translate(352 0)" d="M74 25H143V129H171V165H143V202H97V165H0V129ZM38 129L97 50V129Z"/>
    </svg>
    <h1 class="message">The page you’re looking for can’t be found.</h1>
  </div>
</template>

<style lang="scss" scoped>
.not-found-view {
  height: 100%;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: #FFFFFF;

  .illustration {
    display: block;
    width: min(523px, 80vw);
    height: auto;

    .four {
      fill: #3A3C5B;
    }

    .head {
      fill: #303153;
    }
  }

  .message {
    max-width: 500px;
    margin: min(50px, 8vw) 0 0;
    color: #000000;
    font-size: min(35px, 7vw);
    font-weight: 600;
    line-height: 1.23;
    text-align: center;
  }
}
</style>
